import { useCallback } from "react";

import { ApiError } from "api/types";
import { useCustomMutation } from "api/useCustomMutation";
import { JANZU_URL } from "config/config";
import { UserStatus } from "config/constants";

export type UpdateLabelerStatusData = {
  status: UserStatus;
};

const useUpdateLabelerStatus = () =>
  useCustomMutation<void, UpdateLabelerStatusData>(`${JANZU_URL}device-api/labeler/status`, "PATCH");

type UseLabelerStatusReturn = {
  updateLabelerStatus: (data: UpdateLabelerStatusData) => void;
  isUpdatingLabelerStatus: boolean;
  updateLabelerStatusError: ApiError | null;
};

export function useLabelerStatus(): UseLabelerStatusReturn {
  const { mutate, isLoading, error } = useUpdateLabelerStatus();

  const updateLabelerStatus = useCallback((data: UpdateLabelerStatusData) => mutate(data), [mutate]);

  return {
    updateLabelerStatus,
    isUpdatingLabelerStatus: isLoading,
    updateLabelerStatusError: error,
  };
}
